import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import './index.css';
import logo from '../../../assets/images/s3-logo.png';
import arterLogo from '../../../assets/images/art-er-logo-color.png';
import Info from '@iconscout/react-unicons/icons/uil-info'
import ArrowGrowth from '@iconscout/react-unicons/icons/uil-arrow-growth'
import ListUl from '@iconscout/react-unicons/icons/uil-list-ul'
import DatabaseUl from '@iconscout/react-unicons/icons/uil-database'
import DocumentsUl from '@iconscout/react-unicons/icons/uil-document-info'
import { Select } from '@mantine/core';

import { withTranslation } from 'react-i18next';
import i18next from 'i18next';

class Navbar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchValue: '',
            currentLanguage: localStorage.getItem("language") || 'it',
        }
    }

    changeLanguage = (lng) => {
        i18next.changeLanguage(lng, (err, t) => {
            if (err) {
                return console.log('something went wrong loading', err);
            }
            localStorage.setItem("language", lng);

            this.setState({
                currentLanguage: lng
            })
            // refresh 
            window.location.reload();


        });
    }

    render() {
        const { t, i18n } = this.props;

        // const changeLanguage = lng => {          
        //     i18n.changeLanguage(lng);
        //   };

        return <div>

            <div className='language-header py-2'>
                <div className='d-flex justify-content-between container '>
                    {/* <b>ITA</b> */}

                    <a href="https://www.regione.emilia-romagna.it/" className='er-link my-auto'>Regione Emilia-Romagna</a>
                    <div className='col-lg-1 col-3'>
                        <Select
                            aria-label='Seleziona linguaggio'
                            className='language-select'
                            value={this.state.currentLanguage}
                            onChange={(value) => {
                                this.changeLanguage(value)
                            }}
                            styles={(theme) => ({
                                item: {
                                    // applies styles to selected item
                                    '&[data-selected]': {
                                        '&, &:hover': {
                                            backgroundColor:
                                                "var(--main-color)",
                                            color: "#fff",
                                        },
                                    },
                                    '&[data-hovered]': {},
                                },
                            })}
                            data={[
                                { value: 'it', label: 'ITA' },
                                { value: 'en', label: 'EN' },
                            ]}
                        />
                    </div>
                </div>
            </div>
            <div className='logos-header py-3'>
                <div className='container'>
                    <div className='row'>

                        <div className='col d-flex flex-column flex-md-row'>
                            <div className='d-flex mx-md-0 mx-auto'>
                                <a target="_blank" href="https://www.regione.emilia-romagna.it/" className='logo'>
                                    <img
                                        alt='Regione Emilia-Romagna'
                                        src={logo} />
                                </a>
                                <a target="_blank" href="https://www.art-er.it/" className='logo my-auto ms-4'>
                                    <img
                                        alt='ART-ER'
                                        width={180} className='' src={arterLogo} />
                                </a>
                            </div>
                            <div className='text-start ms-4 my-auto mt-md-0 mt-4'>
                                <NavLink className='logos-link' to="/">
                                    <h3 className='fw-bolder'>{t('common.monitoraggio_s3')}</h3>
                                    <h3 className='fw-bolder'>Smart Specialisation Strategy</h3>
                                </NavLink>
                            </div>
                        </div>

                        {/* <div className='col-md-3 col-12 justify-content-end'>
                            <div className='row d-md-block d-none'>
                                <div className='col'>
                                    {t('navbar.seguici_su')}
                                    <a href="https://www.facebook.com/RegioneEmiliaRomagna"><i className='fab bg-fas fa-facebook my-auto' /></a>
                                    <a href="https://www.instagram.com/regione_emiliaromagna"><i className='fab bg-fas fa-instagram my-auto' /></a>
                                    <a href="https://twitter.com/regioneer"><i className='fab bg-fas fa-twitter my-auto' /></a>
                                    <a href="https://www.youtube.com/user/videoermes"><i className='fab bg-fas fa-youtube my-auto' /></a>
                                    <a href="https://it.linkedin.com/company/regione-emilia-romagna"><i className='fab bg-fas fa-linkedin my-auto' /></a>
                                    <a href="https://open.spotify.com/show/3X1FqLZpzpvR06pTDtQSwj"><i className='fab bg-fas fa-spotify my-auto' /></a>
                                </div>
                            </div>
                            <div className='row mt-2'>
                                <div className='col'>
                                    <div className='form-group d-flex'>
                                        <input
                                            value={this.state.searchValue}
                                            onChange={e => {
                                                this.setState({
                                                    searchValue: e.target.value
                                                })
                                            }}
                                            className='form-control search-input'
                                            placeholder={t('navbar.cerca_nel_sito')} />
                                        <button onClick={(e) => {
                                            e.preventDefault();
                                            console.log(this.state.searchValue)
                                            window.location.href = `https://www.regione.emilia-romagna.it/@@search?SearchableText=${this.state.searchValue}`
                                        }} className='btn btn-search'><i className='fas fa-search' /></button>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            <nav className="navbar navbar-expand-lg navbar-light bg-main py-2">
                <div className="container-fluid">
                    <div className="navbar-child-container mx-auto">
                        <ul className="navbar-nav mx-auto d-flex flex-row">
                            <li className="nav-item">
                                <NavLink
                                    to="/"
                                    className={({ isActive }) =>
                                        isActive ? 'd-flex nav-link active' : 'd-flex nav-link'
                                    }>
                                    {/* <i className='fas bg-fas fa-home my-auto me-2' /> */}
                                    <Info size={30} color="var(--main-color)" className='menu-icon my-auto me-2 p-1' />
                                    <span className='text-menu'>
                                        {t('navbar.panoramica')}
                                    </span>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/cruscotto"
                                    className={({ isActive }) =>
                                        isActive ? 'd-flex nav-link active' : 'd-flex nav-link'
                                    }>
                                    {/* <i className='fas bg-fas fa-line-chart my-auto me-2' /> */}
                                    <ArrowGrowth size={30} color="var(--main-color)" className='menu-icon my-auto me-2 p-1' />
                                    <span className='text-menu'>
                                        {t('navbar.cruscotto')}
                                    </span>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/repository"
                                    className={({ isActive }) =>
                                        isActive ? 'd-flex nav-link active' : 'd-flex nav-link'
                                    }>
                                    {/* <i className='fas bg-fas fa-list my-auto me-2' /> */}
                                    <ListUl size={30} color="var(--main-color)" className='menu-icon my-auto me-2 p-1' />
                                    <span className='text-menu'>
                                        {t('navbar.repository')}
                                    </span>
                                </NavLink>
                            </li>
                            <li className="nav-item ">
                                <NavLink
                                    to="/open-data"
                                    className={({ isActive }) =>
                                        isActive ? 'd-flex nav-link active' : 'd-flex nav-link'
                                    }>
                                    {/* <i className='fas bg-fas fa-list my-auto me-2' /> */}
                                    <DatabaseUl size={30} color="var(--main-color)" className='menu-icon my-auto me-2 p-1' />
                                    <span className='text-menu'>
                                        {t('navbar.open_data')}
                                    </span>
                                </NavLink>
                            </li>
                            <li className="nav-item ">
                                <NavLink
                                    to="/documenti"
                                    className={({ isActive }) =>
                                        isActive ? 'd-flex nav-link active' : 'd-flex nav-link'
                                    }>
                                    {/* <i className='fas bg-fas fa-list my-auto me-2' /> */}
                                    <DocumentsUl size={30} color="var(--main-color)" className='menu-icon my-auto me-2 p-1' />
                                    <span className='text-menu'>
                                        {t('navbar.documenti')}
                                    </span>
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>;
    }
}

export default withTranslation()(Navbar);
